<template>
  <u-padding
    :y="false"
    :x="isAdmin ? ['desktop', 'widescreen', 'fullhd'] : false"
    class="has-background-white"
  >
    <div
      class="is-spaced-apart has-padding-y-75 has-padding-x-100"
      :class="{ container: !isAdmin }"
    >
      <brand-logo
        :brand="$basketData.brandData"
        v-bind="brandLogoArgs"
        fallback="text"
      />

      <basket-avatar />
    </div>
  </u-padding>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Context from "@/mixins/context";
import ClientMixin from "@/mixins/clientMixin";
import { mapGetters } from "vuex";
import type {
  IBasketProviderData
  // IBasketProviderMethods
} from "@/models/providers/baskets";
import { BrandConfigKeys } from "@/data/constants";

export default defineComponent({
  name: "BasketTopper",
  components: {
    "brand-logo": () => import("@/components/app/global/brand/logo.vue"),
    "basket-avatar": () =>
      import("@/components/app/global/baskets/basket/basketAvatar.vue")
  },
  mixins: [Context, ClientMixin],
  inject: {
    basketProviderData: { from: "basketProviderData" },
    $basketMethods: { from: "basketProviderMethods" }
  },
  computed: {
    ...mapGetters({
      brandConfig: "brand/config"
    }),
    logoUrl() {
      return this.brandConfig[BrandConfigKeys.UI_LOGO_URL];
    },
    brandLogoArgs() {
      return this.logoUrl && !this.$store.getters["isAdminContext"]
        ? { tag: "a", href: this.logoUrl }
        : { to: this.$basketData.mainBasketLink };
    },
    $basketData(): IBasketProviderData {
      return this.basketProviderData();
    }
  }
});
</script>
